import { Controller } from '@hotwired/stimulus'

export default class RequestsToggleController extends Controller<HTMLFormElement> {
  static targets = ['confirmTrigger']
  static values = { outstanding: Number }

  declare readonly confirmTriggerTarget: HTMLElement
  declare readonly outstandingValue: number

  submit (event: Event): void {
    const checkbox = event.currentTarget as HTMLInputElement
    const form = this.element as HTMLFormElement

    if (checkbox.checked || this.outstandingValue <= 0) {
      form.submit()

      return
    }

    checkbox.checked = true
    this.confirmTriggerTarget.click()
  }
}
